module.exports = "data:image/svg+xml;base64,PHN2ZwpiYXNlUHJvZmlsZT0idGlueSIKeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgp2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIgo+CjxwYXRoCiAgICBkPSJNMTIwMyA1NDRxMCAxMy0xMCAyM2wtMzkzIDM5MyAzOTMgMzkzcTEwIDEwIDEwIDIzdC0xMCAyM2wtNTAgNTBxLTEwIDEwLTIzIDEwdC0yMy0xMGwtNDY2LTQ2NnEtMTAtMTAtMTAtMjN0MTAtMjNsNDY2LTQ2NnExMC0xMCAyMy0xMHQyMyAxMGw1MCA1MHExMCAxMCAxMCAyM3oiCj48L3BhdGg+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/LeftArrow.svg
// module id = 18je
// module chunks = 1